import * as Yup from 'yup';

export const validationSchemaAddStaff = new Yup.ObjectSchema({
    name:Yup.string().required('Cannot be empty'),
    role:Yup.string().required('Cannot be empty'),
    contact:Yup.string().required('Cannot be empty').matches(/^(?:(?:\+|0{0,2})91|[0])?[6789]\d{9}$/,'Please enter valid phone number'),
    email:Yup.string().required('Cannot be empty').email('Invalid email'),
    password: Yup.string().required('Cannot be empty').min(6,'Password should be atleast 6 character long'),
});

export const initialValuesAddStaff = {
    name: "",
    contact: "",
    role: "",
    services: "",
    staff_color: 0,
    email: "",
    password: "",
    read_access: "",
    write_access: ""
}

export const feildsAddStaff =(options=[]) => [
    {
        name:'name',
        placeholder:'Enter staff name',
        id:'name',
        type:'text',
        label:'Staff Name'
    },
    {
        name:'email',
        placeholder:'Enter email here',
        id:'email',
        type:'email',
        label:'Staff Email'
    },
    {
        name:'contact',
        placeholder:'Enter contact here',
        id:'contact',
        type:'contact',
        label:'Staff contact'
    },
    {
        name:'role',
        placeholder:'Select role',
        id:'role',
        type:'select',
        options:[
            {
                value:'',
                label:'Select Role',
                disabled:true,
            },
            ...options
        ],
        label:'Industry Type'
    },
    {
        name:'password',
        placeholder:'Enter password here',
        id:'password',
        type:'password',
        label:'Password'
    },
];